module.exports = __webpack_public_path__ + "15c0fd55c8b9ab9faeb20cafc0848afe.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_xlarge_x1/public/news/anything_0.jpg
// module id = 351
// module chunks = 0